import { Component, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/shared/Notification.service';
import { DownloadService } from 'src/app/shared/Download.service';

import { LoHangTapTinDinhKem } from 'src/app/shared/LoHangTapTinDinhKem.model';
import { LoHangTapTinDinhKemService } from 'src/app/shared/LoHangTapTinDinhKem.service';

@Component({
  selector: 'app-to-chuc-detail',
  templateUrl: './to-chuc-detail.component.html',
  styleUrls: ['./to-chuc-detail.component.css']
})
export class ToChucDetailComponent {

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ToChucDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    public NotificationService: NotificationService,
    public DownloadService: DownloadService,

    public LoHangTapTinDinhKemService: LoHangTapTinDinhKemService,
  ) { }

  Close() {
    this.dialogRef.close();
  }
}